
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/[courses_slug]",
      function () {
        return require("private-next-pages/courses/[courses_slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/[courses_slug]"])
      });
    }
  